<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface"><br/><br/><br/><br/>
<h1>Preface</h1><br/><br/><br/>
<p>Humanity is destroyed by a great predator, man, who leads us inexorably to our own alienation.</p>
<p style="text-align: right;margin-right:69px">Azzedine Kechroud</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5efe2fac